module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("4l34J"))).then(() => parcelRequire('7eBQO'));